import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import fetchData from 'utils/fetchData';
import stringUtilities from 'utils/stringUtilities';

export default function MyExams2() {
    const [rows, setRows] = useState([]);

    async function GetData() {
        try {
            var pResponse = await fetchData.Post('/api/ExamSchedules/Get', {
                showJobPosition: true
            });
            setRows(pResponse.rows);
        } catch (e) {
            toast.error(e);
        }
    }

    useEffect(() => {
        GetData();
    }, []);

    return (
        <div>
            <div class="tab" role="group">
                <a href="/#/my-schedule"
                    type="button"

                    disabled
                >
                    Interviews
                </a>

                <a href="/#/my-exams-2" className="active">
                    Exams
                </a>
            </div>

            <div className="datagrid" style={{ maxHeight: "calc(100vh - 160px)" }}>
                <table>
                    <thead>
                        <tr>
                            <th>Job Title</th>
                            <th>Date From</th>
                            <th>Date To</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map(row => {
                            return <tr>
                                <td>
                                    {row.jobPositionName}
                                </td>
                                <td>{stringUtilities.FormatDate(row.dateStart)}</td>
                                <td>{stringUtilities.FormatDate(row.dateEnd)}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>

        </div>
    )
}
